#import "./UserGroupFields.graphql"
query UserGroups(
  $orderBy: [UserGroupsOrderBy!]
  $first: Int
  $after: Cursor
  $filter: UserGroupFilter
) {
  userGroups(first: $first, orderBy: $orderBy, filter: $filter, after: $after) {
    nodes {
      ...UserGroupFields
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      endCursor
    }
    totalCount
  }
}
